<template>
    <div class="accordeon-area">
        <div :id="'accordeon_'+id">
            <div
                v-for="(item, index) in items"
                class="card mb-2"
                :key="index"
                :class="{ 'selected-accordeon': index === selectedIndex }"
            >
                <div class="card-header" :id="'heading' + index">
                    <h5 class="mb-0">
                        <button
                            class="btn btn-link"
                            data-toggle="collapse"
                            :data-target="'#collapse_' + id + '_' + index"
                            :aria-expanded="index === selectedIndex"
                            :aria-controls="'heading' + index"
                            @click="select(index)"
                        >
                            {{item.title}}
                        </button>
                    </h5>
                </div>
                <div :id="'collapse_' + id + '_' + index" class="collapse pl-4 pr-4" :aria-labelledby="'heading'+index"
                     :data-parent="'#accordeon_'+id">
                    <div class="card-body pt-0" v-html="item.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['items', 'defaultIndex', 'id'],
        data: () => {
            return {
                selectedIndex: null,
            }
        },
        methods: {
            select: function(index) {
                this.selectedIndex = index;
            }
        },
        mounted() {
            if (!this.defaultIndex) {
                return;
            }

            this.select(this.defaultIndex)

            $('#collapse' + this.defaultIndex).collapse('show');
        }
    }
</script>
